<template>
<div class="chapter">
<div class="inner_page">
<p class="center3"><span><a id="page-v">“Saintliness is also a temptation.”</a></span></p><a id="page-v">
<p class="attribution"><span>—Jean Anouilh</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?d605ae46